export const DevModeBanner = () => {
  return (
    <div></div>

  );
};
